<template>
  <div
    data-testid="loadingbox"
    class="flex flex-col items-center justify-center py-14 rounded-md bg-surface-modal"
  >
    <nuxt-icon
      class="text-24 text-grey-500 [&>*]:animate-spin-slow-ease [&>*]:motion-reduce:animate-none"
      name="refresh"
      alt="laddningssymbol"
    />
    <p class="text-text-on-highlight">
      {{ message }}
    </p>
  </div>
</template>
<script lang="ts" setup>
defineProps<{ message: string }>();
</script>
<style lang="scss" scoped></style>
